import { NavLink } from "react-router-dom";
import Banner from "../../components/banner/Banner";

function PrivacyPolicyPage(props: { isConnect: boolean }) {
  return (
    <>

      <Banner isConnect={props.isConnect} showBtnHome={true} />

      <h1 className="text-4xl font-bold text-center p-4 text-greenCustom">Politique de confidentialité</h1>

      <section className="text-start p-4">
        <h2 className="text-3xl font-bold text-start pb-2">1. Introduction</h2>
        <p>Cette politique de confidentialité explique quelles informations nous collectons, comment nous les utilisons et quels sont tes droits.</p>
      </section>

      <section className="text-start p-4">
        <h2 className="text-3xl font-bold text-start pb-2">2. Données Collectées</h2>
        <p> <strong>Cemade</strong> recueille uniquement les données personnelles strictement nécessaires en fonction des objectifs pour lesquels elles sont traitées. Les types de données collectées sont les suivants :</p>
        <ul className="list-disc">
          <li className="ml-6"><strong>Informations personnelles : </strong>adresse e-mail, pseudo, nom et prénom(pour inscription et gestion de compte), région (si résident), données sur tes éléments d'échange créés et discussions.</li>
          <li className="ml-6"><strong>Données de facturation :</strong> données nécessaires à la gestion des paiements via un prestataire sécurisé.</li>
          <li className="ml-6"><strong>Données de connexion :</strong> adresse IP, agent utilisateur de ton navigateur (pour aider à la détection des utilisateurs indésirables, ne respectant pas la politique de l'application), position de ton appareil (pour rechercher les partenaires de trocs disponibles).</li>
        </ul>


        <h3 className="pt-2 text-lg">2.1 Données des mineurs</h3>
        <p className="pt-2">L'application Cemade n'est pas destinée aux mineurs de moins de 16 ans. Nous ne collectons pas délibérément des données personnelles auprès de mineurs sans le consentement préalable d'un parent ou tuteur légal.</p>


        <h3 className="pt-2 text-lg">2.2 Base légale du traitement</h3>
        <ul className="pt-2">Le traitement de tes données personnelles est effectué sur la base des fondements suivants :
          <li>- Exécution du contrat : pour la gestion de ton compte et l'exécution des services proposés par l’application.</li>
          <li>- Consentement : pour la collecte de certaines informations comme ta position géographique ou tes préférences.</li>
          <li>- Obligation légale : pour répondre aux exigences légales et réglementaires, notamment pour la facturation.</li>
          <li>- Intérêt légitime : pour assurer la sécurité de l’application, prévenir la fraude et optimiser l'expérience utilisateur.</li>
        </ul>
      </section>

      <section className="text-start p-4">
        <h2 className="text-3xl font-bold text-start pb-2">3. Utilisation des Données</h2>
        <p>Les données collectées sont utilisées pour :</p>
        <ul className="list-disc">
          <li className="ml-6">Fournir et améliorer nos services.</li>
          <li className="ml-6">Gérer ton compte et tes abonnements.</li>
          <li className="ml-6">Traiter les transactions et assurer la facturation.</li>
          <li className="ml-6">Améliorer l'expérience utilisateur via des analyses statistiques.</li>
          <li className="ml-6">Envoyer des notifications et des communications importantes.</li>
          <li className="ml-6">Recueillir les demandes d’informations et réclamations des utilisateurs de l'application</li>
          <li className="ml-6">Informer sur de nouveaux services et avantages.</li>



        </ul>
      </section>

      <section className="text-start p-4">
        <h2 className="text-3xl font-bold text-start pb-2">4. Fonctionnalité d’Assistant IA</h2>
        <p>
          L'application Cemade intègre une fonctionnalité facultative d’assistance basée sur une intelligence artificielle (IA), accessible depuis la page d’accueil.
          Cet assistant conversationnel repose sur l’API OpenAI et a pour seul objectif d’informer l’utilisateur sur le fonctionnement de l’application, ses règles, ainsi que les modalités d’échange.
        </p>
        <p className="pt-2">
          Aucune information personnelle n’est demandée ou requise pour utiliser cette fonctionnalité, et les réponses ne sont ni stockées ni liées à un compte utilisateur.
          L’utilisateur est informé via une mention affichée que les réponses sont générées automatiquement et peuvent comporter des inexactitudes.
        </p>
        <p className="pt-2">
          Un filtrage automatique est mis en place par le fournisseur de l’API pour éviter toute production de contenu inapproprié ou contraire à la loi.
          L’utilisation de l’assistant IA est totalement facultative et n’est pas nécessaire pour profiter des services de Cemade.
        </p>
      </section>

      <section className="text-start p-4">
        <h2 className="text-3xl font-bold text-start pb-2">5. Partage des Données</h2>
        <p>Nous ne partageons tes données personnelles qu'avec les tiers suivants :</p>
        <ul className="list-disc">
          <li className="ml-6"><strong>Prestataires de services</strong> (Ces prestataires sont soigneusement sélectionnés et contractuellement engagés à respecter la confidentialité et la sécurité des données) : <br /> pour le traitement des paiements (Stripe), l'hébergement de données (OVH SAS), les services d'emailing ou de géolocalisation.</li>
          <li className="ml-6"><strong>Autorités légales :</strong> en cas d'obligation légale.</li>
          <li className="ml-6">Certaines données personnelles peuvent être transférées en dehors de l'Union Européenne, notamment vers des prestataires de services comme Stripe. Dans ce cas, des garanties appropriées sont mises en place pour assurer un niveau de protection des données personnelles équivalent à celui exigé par les lois européennes.</li>
        </ul>
      </section>

      <section className="text-start p-4">
        <h2 className="text-3xl font-bold text-start pb-2">6. Conservation des Données</h2>
        <p>Tes données personnelles sont conservées uniquement pendant la durée nécessaire aux finalités pour lesquelles elles ont été collectées et dans la limite de la loi en vigueur.</p>
      </section>

      <section className="text-start p-4">
        <h2 className="text-3xl font-bold text-start pb-2">7. Sécurité des Données</h2>
        <p>Nous prenons des mesures de sécurité appropriées pour protéger tes données contre tout accès non autorisé, altération, divulgation ou destruction.</p>
      </section>

      <section className="text-start p-4">
        <h2 className="text-3xl font-bold text-start pb-2">8. Vos Droits</h2>
        <p>Conformément au RGPD, tu disposes des droits suivants :</p>
        <ul className="list-disc">
          <li className="ml-6"><strong>Droit d'accès :</strong> consulter les données que nous détenons à ton sujet.</li>
          <li className="ml-6"><strong>Droit de rectification :</strong> corriger des informations incorrectes ou incomplètes.</li>
          <li className="ml-6"><strong>Droit de suppression :</strong> demander la suppression de tes données personnelles.</li>
          <li className="ml-6"><strong>Droit d'opposition :</strong> t'opposer au traitement de tes données dans certains cas.</li>
          <li className="ml-6"><strong>Droit de portabilité :</strong> récupérer tes données dans un format structuré.</li>
          <li className="ml-6">Si tu estimes que tes droits relatifs à la protection de tes données personnelles ne sont pas respectés, tu as le droit de déposer une plainte auprès de la Commission Nationale de l'Informatique et des Libertés (CNIL), l'autorité de protection des données en France. Tu peux contacter la CNIL via leur site web : [https://www.cnil.fr](https://www.cnil.fr).</li>
        </ul>
        <p>Pour exercer tes droits, contacte-nous <strong><NavLink to={'/contact'}>via ce formulaire.</NavLink></strong>.</p>
      </section>

      <section className="text-start p-4">
        <h2 className="text-3xl font-bold text-start pb-2">9. Suppression de compte et données</h2>
        <p>Les utilisateurs de l'application Cemade peuvent à tout moment demander la suppression de leur compte et des données associées en suivant la procédure ci-dessous :</p>
        <ol className="list-decimal ml-6 my-4">
          <li>Connecte toi à ton compte</li>
          <li>Rends toi sur ton profil</li>
          <li>Clique sur le boutton supprimer mon compte</li>
          <li>Confirmer la demande. La suppression est irréversible.</li>
        </ol>
        <p>Les données supprimées comprennent : nom, prénom, email, contenu de profil, publications, messages, etc.</p>
        <p>Nous conservons uniquement les données nécessaires à des obligations légales pour une durée maximale de six mois, sauf obligation contraire.</p>
        <p>Pour toute question complémentaire, contacte-nous <strong><NavLink to="/contact">via ce formulaire.</NavLink></strong></p>
      </section>

      <section className="text-start p-4">
        <h2 className="text-3xl font-bold text-start pb-2">10. Cookies</h2>
        <p>
          L'application Cemade ne fait pas usage de cookies pour le suivi de l'activité utilisateur. Cependant, certaines informations peuvent être temporairement stockées localement sur ton appareil. Il s'agit d'informations nécessaires au bon fonctionnement de certaines fonctionnalités de l’application, telles que ta position géographique à ta demande, ou des données spécifiques liées à ton utilisation de l'application. Ces informations ne sont utilisées qu'à des fins fonctionnelles et ne sont pas conservées au-delà de la session ou de la période nécessaire à leur traitement.
        </p>
      </section>

      <section className="text-start px-4 pt-4 pb-8">
        <h2 className="text-3xl font-bold text-start pb-2">11. Modifications de la Politique de Confidentialité</h2>
        <p>Nous pouvons modifier cette politique de confidentialité à tout moment. En cas de mise à jour importante, tu seras informé via notre application web ou par email.</p>
      </section>
    </>
  )
}
export default PrivacyPolicyPage;